import { mapMutations } from 'vuex'
import i18n from '../i18n';
import customerOps from '../api/users'

export const customerMixin = {
  data() {
    return {
      accountIdValidationInfo: {},
      authorizationURI: '',
      configurationRules: {
        configLabel: [
          value => !!value || i18n.t('validation.configLabel.isRequired'),
        ],
        clientId: [
          value => !!value || i18n.t('validation.clientId.isRequired'),
        ],
        clientSecret: [
          value => !!value || i18n.t('validation.clientSecret.isRequired'),
        ],
        apiToken: [
          value => !!value || i18n.t('validation.appLoginInfo.isRequired'),
        ],
        redirectURI: [
          value => !!value || i18n.t('validation.redirectUri.isRequired'),
        ],
        authorizationURI: [
          value => !!value || i18n.t('validation.authorizationUri.isRequired'),
        ],
        tokenURI: [
          value => !!value || i18n.t('validation.tokenUri.isRequired'),
        ],
        subdomain: [
          value => !!value || i18n.t('validation.subdomain.isRequired'),
        ], 
      },
      crm: '',
      customerProfile : {},
      addFieldRules: {
        fieldName: [
          value => !!value || i18n.t('validation.fieldName.isRequired'),
        ],
        fieldId: [
          value => !!value || i18n.t('validation.fieldId.isRequired'),
        ],
        label: [
          value => !!value || i18n.t('validation.label.isRequired'),
        ],
        dataType: [
          value => !!value || i18n.t('validation.dataType.isRequired'),
        ],
        // requiredField: [
        //   value => !!value || 'Please select required field.',
        // ],
        preSelectList: [
          value => !!value || i18n.t('validation.tags.isRequired'),
        ]
      },
      linkTranscriptConfigRules: {
        livePerson: {
          appKey: [
            value => !!value || i18n.t('validation.linkTranscriptConfigRules.livePerson.appKey.isRequired'),
          ],
          appSecret: [
            value => !!value || i18n.t('validation.linkTranscriptConfigRules.livePerson.appSecret.isRequired'),
          ],
          token: [
            value => !!value || i18n.t('validation.linkTranscriptConfigRules.livePerson.token.isRequired'),
          ],
          tokenSecret: [
            value => !!value || i18n.t('validation.linkTranscriptConfigRules.livePerson.tokenSecret.isRequired'),
          ]
        },
        twilioFlex: {
          accountSid: [
            value => !!value || i18n.t('validation.linkTranscriptConfigRules.twilioFlex.accountSid.isRequired'),
          ],
          authToken: [
            value => !!value || i18n.t('validation.linkTranscriptConfigRules.twilioFlex.authToken.isRequired'),
          ],
          serviceSid: [
            value => !!value || i18n.t('validation.linkTranscriptConfigRules.twilioFlex.serviceSid.isRequired'),
          ]
        }
      },
      entityDialogPersistentStatus: false,
    };
  },
  methods: {
    /**
      * @desc Preparing pre-filled values for config fields redirectURI and authorizationURI
      * @param string fieldName: config field name; crmInstance: crm instance value;
      * @returns Pre-filled values for config fields redirectURI and authorizationURI
    */
    getPreFilledValue (fieldName, crmInstance) {
      if(fieldName === 'redirectURI') {
        // Redirect URI field
        let hostname = window.location.href;
        let arr = hostname.split("/");
        let url = `${arr[0]}//${arr[2]}/widget/authsession`;
        return url;
      } else if(fieldName === 'authorizationURI') {  
        // Authorization URI field
        if(crmInstance === "DYNAMICS") this.authorizationURI = '';
        else if (crmInstance === "ZENDESK") this.authorizationURI = '';
        else if (crmInstance === "SALESFORCE") this.authorizationURI = 'https://login.salesforce.com/services/oauth2/authorize';    
        return this.authorizationURI;
      }
    },
    async verifyAccountID (data) {    
      let hostname = window.location.hostname;
      hostname = (hostname === 'crmconnect.navomi.com') ? 'production' : 'development';
      
      this.accountIdValidationInfo = {
        status: true,
        message: ''
      }

      if ((data.operation === 'signup' && hostname === 'production') ||
        (data.operation === 'linktranscript' && hostname === 'development')
      ) {
        if (data.platform === 'LIVEPERSON') { 
          await customerOps.verifyAccountID(data.accountId)
          .then(response => {
            if (!response) {
              this.accountIdValidationInfo.status = !this.accountIdValidationInfo.status;
              if (data.operation === 'signup') this.accountIdValidationInfo.message = i18n.t('registration.invalidLeAccountNumber');
              else this.accountIdValidationInfo.message = i18n.t('customer.linkTranscript.invalidLeAccountNumber');
            }
          })
          .catch(error => {
            this.accountIdValidationInfo.status = !this.accountIdValidationInfo.status;
            if (data.operation === 'signup') this.accountIdValidationInfo.message = i18n.t('registration.invalidLeAccountNumber');
            else this.accountIdValidationInfo.message = i18n.t('customer.linkTranscript.invalidLeAccountNumber');
          })
        } 
      }
    },
    showSnack: function (snack, isError) {
      const setSnackObj = {
        message: snack,
        isError: !!isError
      }
      this.setSnack(setSnackObj)
    },
    ...mapMutations({
      setSnack: 'setSnack'
    }),
    scrollToTop () {
      window.scrollTo(0,0);
    },
    toCapitalCase: (value) => {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }
};